import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";

export const SPACE_CONSTANTS = {
  PAGE_TITLE_SEARCH: "Espacios",
  PAGE_TITLE_CREATE: "Agregar espacio",
  PAGE_TITLE_EDIT: "Editar espacio",
  LABEL: {
    NAME: "Nombre espacio*",
    STATE: "Activo",
    ADD_CAMPUS: "Sede*"
  },
  BUTTON: {
    ADD_SPACE: "Crear espacio"
  },
  DELETE_MODAL: {
    TITLE: "Eliminar espacio",
    TEXT: "Ingrese la razón por la cual va a deshabilitar el espacio:"
  },
  MESSAGE: {
    MAX_LENGTH: "Máximo 50 caracteres",
    SPACE_EXISTS: "El espacio existe",
    SPACE_USED: "El espacio está en uso, no se puede eliminar",
    NOT_FOUND_CAMPUS: "No se encontraron sedes"
  },
  DIALOG_MESSAGE: {
    EXIST: "El espacio existe",
    NOT_EXIST: "El espacio no existe",
    FOUND_ALL: "Se han encontrado espacios",
    NOT_FOUND_ALL: "No se han encontrado espacios",
    FOUND: "Se han encontrado un espacio",
    NOT_FOUND: "No se han encontrado un espacio",
    ERROR_SAVE: "Ocurrió un error al guardar",
    USED: "El espacio está en uso, no se puede eliminar",
    NOT_USED: "El espacio no está en uso",
    DELETED: "espacio eliminado",
    DELETE_FAILED: "El espacio a eliminar no existe",
    UPDATE: "Se ha actualizado de forma exitosa",
    UPDATE_FAILED: "El espacio no pudo actualizarse",
    SAVE: "El espacio se ha guardado con éxito",
    SAVE_FAILED: "Ha ocurrido un error, intente más tarde."
  }
};

export const SPACE_VALIDATORS = {
  MAX_LENGTH: (v: string) =>
    v.length <= 50 || SPACE_CONSTANTS.MESSAGE.MAX_LENGTH
};

export const QUERY_STATE_ACTIVE = {
  VOIDED: "false"
};

export const SPACE_FILTERS: Filter[] = [
  {
    mainFilterKey: "spaces",
    mainFilterName: "Espacios",
    avatar: "mdi-shape-plus",
    initial: true,
    placeholder: "Seleccione los filtros deseados para los Espacios",
    secondaryFilters: [
      {
        name: "Nombre",
        placeholder: "Nombre de Espacio",
        key: "name",
        display: "unique",
        default: true,
        operators: OPERATORS_FILTERS,
        type: "secondaryFilter"
      },
      {
        default: false,
        name: "Estado",
        placeholder: "Estado de Espacio",
        key: "state",
        type: "secondaryFilter",
        display: "list",
        options: [
          { key: "Activo", name: "Activo" },
          { key: "Inactivo", name: "Inactivo" }
        ],
        operators: OPERATORS_FILTERS
      }
    ]
  }
];

export const SPACES_ACCESS = {
  GET: "consultar espacios",
  POST: "crear espacios",
  PUT: "modificar espacios",
  DELETE: "eliminar espacios"
};
